/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import focus from '../focus/focus-directive';

import SetupHeader from './setup-header';
import template from './setup-manual.html';

export default {
  name: 'SetupManual',
  template,
  components: { SetupHeader },
  created() {
    this.submitted = false;
  },
  directives: { focus },
  data() {
    return {
      field: {
        deviceName: {
          label: 'Device name (optional)',
          value: this.deviceName
        },
        password: {
          label: 'Password',
          validator: 'required',
          value: this.password
        },
        username: {
          label: 'Username',
          validator: 'required',
          value: this.username
        }
      }
    };
  },
  methods: {
    handleError(error) {
      this.$root.logger.error(error);
    },
    onBack() {
      this.$emit('back');
    },
    onChange() {
      new Promise((resolve) => {
        if (!this.submitted) {
          return resolve();
        }
        return resolve(this.$validator.validateAll());
      }).catch((error) => this.handleError(error));
    },
    onSubmit() {
      new Promise((resolve) => {
        this.submitted = true;
        return resolve(this.$validator.validateAll());
      })
        .then((valid) => {
          if (!valid) {
            return;
          }
          const { field } = this;
          this.$emit(
            'submit',
            field.deviceName.value,
            field.username.value,
            field.password.value
          );
        })
        .catch((error) => this.handleError(error));
    }
  },
  props: ['deviceName', 'isOnline', 'password', 'username']
};
